// extracted by mini-css-extract-plugin
export default {"component":"DepositRefundItem_component__AVa+l","text":"DepositRefundItem_text__AMAvy","amount":"DepositRefundItem_amount__zECeD","children":"DepositRefundItem_children__gl+Cc"};